'use client';

import { useRouter } from 'next/navigation';
import type React from 'react';
import { useCallback } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import Button from '@/shared/Buttons/Button';
import { Icons } from '@/shared/Icons/Icons';
import Tabs, { type TabItem } from '@/shared/Tabs/Tabs';
import FormSearch from '@/widgets/MainBlock/MainSearch/FormSearch/FormSearch';
import type { DefaultFilterT } from '@/widgets/MainBlock/MainSearch/types';
import { DEFAULT_SEARCH_TYPE } from '@/forApp/utils/constants';
import { getRouteHref, ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

type MainSearchT = {
  defaultFilter: DefaultFilterT;
};

const tabs: TabItem[] = [
  { title: 'Купить', value: 'sale' },
  { title: 'Снять', value: 'rent' },
];

const MainSearch: React.FC<MainSearchT> = ({ defaultFilter }) => {
  const { filters, setFilters } = useApp();
  const router = useRouter();

  const handleSearch = useCallback(
    (typeSearch?: string) => {
      try {
        const chosenType =
          (filters?.extraType as string) ||
          (filters?.type as string) ||
          DEFAULT_SEARCH_TYPE;
        const city = (filters?.['filters[city]'] as string) || '';
        const adType = (filters?.['filters[ad_type]'] as string) || '';
        const params = new URLSearchParams();
        Object.entries(filters || {}).forEach(([key, value]) => {
          if (key === 'type') return; // type goes into the path
          if (key === 'extraType') return; // extraType goes into the path (legacy removed from query)
          if (key === 'filters[city]') return; // city goes into the path when present
          if (key === 'filters[ad_type]') return; // adType goes into the path when present
          if (value === undefined || value === null) return;
          if (Array.isArray(value)) {
            value
              .filter((v) => v !== '' && v !== null && v !== undefined)
              .forEach((v) => params.append(key, String(v)));
          } else {
            const v = String(value);
            if (v !== '') params.append(key, v);
          }
        });

        // не знаю, нужен ли этот код
        if (city) params.set('filters[city]', city);
        if (adType) params.set('filters[ad_type]', adType);

        let href = getRouteHref(
          typeSearch === 'maps' ? ROUTES.MAP : ROUTES.CATALOG,
          { type: chosenType },
        );

        const finalQs = params.toString();
        if (finalQs) href += `?${finalQs}`;
        router.push(href);
      } catch {
        // fail-safe: go to base catalog
        const chosenType =
          (filters?.extraType as string) ||
          (filters?.type as string) ||
          DEFAULT_SEARCH_TYPE;
        // const city = (filters?.['filters[city]'] as string) || '';
        // const adType = (filters?.['filters[ad_type]'] as string) || '';
        router.push(
          getRouteHref(typeSearch === 'maps' ? ROUTES.MAP : ROUTES.CATALOG, {
            type: chosenType,
          }),
        );
      }
    },
    [filters, router],
  );

  return (
    <div className={styles.mainSearch}>
      <Tabs
        tabs={tabs}
        activeTab={filters['filters[ad_type]'] as string}
        onTabChange={(value) => setFilters('filters[ad_type]', value)}
      />
      <FormSearch defaultFilter={defaultFilter} />
      <div className={styles.btnBlock}>
        <Button
          color={'white'}
          text={'Показать на карте'}
          className={styles.showMap}
          icon={<Icons.Point />}
          onClick={() => {
            handleSearch('maps');
          }}
        />
        <Button
          text={'Найти'}
          onClick={() => {
            handleSearch();
          }}
        />
      </div>
    </div>
  );
};

export default MainSearch;
